// import { Button, Card, DatePicker, Form, Input, message } from "antd";
// import { useEffect, useState } from "react";
// import { Col, Row } from "react-bootstrap";
// import { API } from "../../config/Api";
// import { COMPRESS_IMAGE, POST } from "../../utils/apiRequest";
// import ImagePicker from "../components/imagePicker";
// import dayjs from "dayjs";

// const EditProfile = (props: any) => {
//   const [form] = Form.useForm();
//   const [isLoading, setIsLoading] = useState(false);
//   const [idProofImage, setIdProofImage] = useState<any>(props?.data?.photo);

//   const handleSubmit = async (values: any) => {
//     try {
//       setIsLoading(true);
//       let imageUrl = props?.data?.photo;

//       if (idProofImage?.file) {
//         const upload = await COMPRESS_IMAGE(idProofImage?.file);
//         if (!upload?.url) {
//           return message.error("Image upload failed");
//         }
//         imageUrl = upload.url;
//       }
//       const requestPayload = {
//         id: props?.data?.id,
//         first_name: values.first_name,
//         last_name: values.last_name,
//         mobile_number: values.mobile_number,
//         mobile_number2: values.mobile_number2,
//         birth_date: values.birth_date,
//         place: values.place,
//         email: values.email,
//         photo: imageUrl?.url || props?.data?.photo,
//       };
//       console.log("===============requestPayload=====================");
//       console.log(requestPayload);
//       console.log("===============requestPayload=====================");
//       const response: any = await POST(API.USER_UPDATE, requestPayload);

//       if (response?.status) {
//         message.success(response?.message || "Successfully updated");
//         props?.reload();
//       } else {
//         message.error(response?.message || "Update failed");
//       }
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       message.error("An error occurred while updating the profile");
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (props?.data) {
//       form.setFieldsValue({
//         first_name: props?.data?.first_name || "",
//         last_name: props?.data?.last_name || "",
//         mobile_number: props?.data?.mobile_number || "",
//         mobile_number2: props?.data?.mobile_number2 || "",
//         birth_date: props?.data?.birth_date
//           ? dayjs(props?.data?.birth_date, "YYYY/MM/DD")
//           : null,
//         place: props?.data?.place || "",
//         email: props?.data?.email || "",
//       });
//     }
//   }, [props?.data, form]);
//   return (
//     <Card className="col-12 col-lg-8">
//       <h5 className="user-heading">Edit Profile</h5>
//       <Form form={form} layout="vertical" onFinish={handleSubmit}>
//         <Row>
//           <Col md={6}>
//             <Form.Item
//               label="First Name"
//               name="first_name"
//               rules={[{ required: true, message: "First name is required" }]}
//             >
//               <Input placeholder="Enter your first name" />
//             </Form.Item>

//             <Form.Item
//               label="Mobile Number"
//               name="mobile_number"
//               rules={[{ required: true, message: "Mobile number is required" }]}
//             >
//               <Input placeholder="Enter your mobile number" type="tel" />
//             </Form.Item>

//             <Form.Item
//               label="Birth Date"
//               name="birth_date"
//               rules={[{ required: true, message: "Birth date is required" }]}
//             >
//               <DatePicker
//                 placeholder="Select your birth date"
//                 className="w-100"
//               />
//             </Form.Item>

//             <Form.Item label="User Image">
//               <ImagePicker
//                 fileURL={idProofImage?.url || props?.data?.photo}
//                 onChange={setIdProofImage}
//                 aspectRatio={1 / 1}
//                 height="30vh"
//               />
//             </Form.Item>
//           </Col>

//           <Col md={6}>
//             <Form.Item
//               label="Last Name"
//               name="last_name"
//               rules={[{ required: true, message: "Last name is required" }]}
//             >
//               <Input placeholder="Enter your last name" />
//             </Form.Item>

//             <Form.Item label="Alternate Mobile Number" name="mobile_number2">
//               <Input placeholder="Enter your alternate mobile number" />
//             </Form.Item>

//             <Form.Item label="Place" name="place">
//               <Input placeholder="Enter your place" />
//             </Form.Item>

//             <Form.Item
//               label="Email"
//               name="email"
//               rules={[
//                 { required: true, message: "Email is required" },
//                 { type: "email", message: "Enter a valid email address" },
//               ]}
//             >
//               <Input placeholder="Enter your email" />
//             </Form.Item>
//           </Col>
//           <Col></Col>
//           <Col className="mt-3">
//             <Form.Item>
//               <Button
//                 block
//                 type="primary"
//                 htmlType="submit"
//                 loading={isLoading}
//               >
//                 Update
//               </Button>
//             </Form.Item>
//           </Col>
//         </Row>
//       </Form>
//     </Card>
//   );
// };

// export default EditProfile;
import { Button, Card, DatePicker, Form, Input, message } from "antd";
import { useEffect, useState, useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import { API } from "../../config/Api";
import { COMPRESS_IMAGE, POST } from "../../utils/apiRequest";
import ImagePicker from "../components/imagePicker";
import dayjs from "dayjs";

const EditProfile = ({ data, reload }: any) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [idProofImage, setIdProofImage] = useState(data?.photo || null);
  const [imageError, setImageError] = useState("");

  const handleImageChange = useCallback((newImage: any) => {
    setIdProofImage(newImage);
    setImageError("");
  }, []);

  const handleSubmit = async (values: any) => {
    // Validate image
    if (!idProofImage) {
      setImageError("Profile image is required");
      return;
    }

    setIsLoading(true);
    try {
      // Process image
      let imageUrl = data?.photo;
      if (idProofImage?.file) {
        try {
          const upload = await COMPRESS_IMAGE(idProofImage.file);
          if (upload?.url) {
            imageUrl = upload.url;
          } else {
            throw new Error("Image upload failed");
          }
        } catch (error) {
          message.error("Image upload failed. Please try again.");
          setIsLoading(false);
          return;
        }
      } else if (idProofImage?.url) {
        imageUrl = idProofImage.url;
      } else if (typeof idProofImage === "string") {
        imageUrl = idProofImage;
      }

      // Prepare and send payload
      const response: any = await POST(API.USER_UPDATE, {
        id: data?.id,
        first_name: values.first_name,
        last_name: values.last_name,
        mobile_number: values.mobile_number,
        mobile_number2: values.mobile_number2,
        birth_date: values.birth_date,
        place: values.place,
        email: values.email,
        photo: imageUrl,
      });

      if (response?.status) {
        message.success(response?.message || "Profile updated successfully");
        reload?.();
      } else {
        message.error(response?.message || "Update failed");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      message.error("Failed to update profile");
    } finally {
      setIsLoading(false);
    }
  };

  // Initialize form values
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        mobile_number: data.mobile_number || "",
        mobile_number2: data.mobile_number2 || "",
        birth_date: data.birth_date
          ? dayjs(data.birth_date, "YYYY/MM/DD")
          : null,
        place: data.place || "",
        email: data.email || "",
      });
      setIdProofImage(data.photo || null);
    }
  }, [data, form]);

  return (
    <Card className="col-12 col-lg-8">
      <h5 className="user-heading">Edit Profile</h5>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row>
          <Col md={6}>
            <Form.Item
              label="First Name"
              name="first_name"
              rules={[{ required: true, message: "First name is required" }]}
            >
              <Input placeholder="Enter your first name" />
            </Form.Item>

            <Form.Item
              label="Mobile Number"
              name="mobile_number"
              rules={[{ required: true, message: "Mobile number is required" }]}
            >
              <Input placeholder="Enter your mobile number" type="tel" />
            </Form.Item>

            <Form.Item
              label="Birth Date"
              name="birth_date"
              rules={[{ required: true, message: "Birth date is required" }]}
            >
              <DatePicker
                placeholder="Select your birth date"
                className="w-100"
              />
            </Form.Item>

            <Form.Item
              label={
                <>
                  User Image <span className="text-danger">*</span>
                </>
              }
              validateStatus={imageError ? "error" : ""}
              help={imageError}
              required
            >
              <ImagePicker
                fileURL={
                  typeof idProofImage === "string"
                    ? idProofImage
                    : idProofImage?.url
                }
                onChange={handleImageChange}
                aspectRatio={1 / 1}
                height="30vh"
              />
              <div className="mt-2 text-secondary">
                <small>JPG or PNG, max 5MB</small>
              </div>
            </Form.Item>
          </Col>

          <Col md={6}>
            <Form.Item
              label="Last Name"
              name="last_name"
              rules={[{ required: true, message: "Last name is required" }]}
            >
              <Input placeholder="Enter your last name" />
            </Form.Item>

            <Form.Item label="Alternate Mobile Number" name="mobile_number2">
              <Input placeholder="Enter your alternate mobile number" />
            </Form.Item>

            <Form.Item label="Place" name="place">
              <Input placeholder="Enter your place" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Email is required" },
                { type: "email", message: "Enter a valid email address" },
              ]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>
            <Form.Item />
            <Form.Item />

            <Form.Item>
              <Button
                block
                type="primary"
                htmlType="submit"
                loading={isLoading}
              >
                Update
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default EditProfile;
